export const settings = {
  setShareTitle: "Partager l'application",
  setNotifiationsTitle: 'Notifications',
  setContactAppOwnerTitle: "Contacter le propriétaire de l'application",
  setContactDevelopersTitle: 'Contacter les développeurs',
  setReportAppTitle: "Signaler l'application",
  setDeleteAccountTitle: 'Supprimer le compte',
  setLogOutTitle: 'Se déconnecter',
  setShareAppCurtainTitle: "Partager l'application",
  setShareAppCurtainButtonTitle: 'Copier le lien',
  setShareAppAlertWhenAppLinkWasCopied: 'Lien copié !',
  setNotificationsInAppTitle: "Dans l'application",
  setNotificationsPushContent: 'Notifications Push',
  setNotificationsChatsTitle: 'Chats',
  setNotificationsDiscussionsTitle: 'Discussions',
  setNotificationsNewsTitle: "Fil d'actualité",
  setNotificationsEventsTitle: 'Événements',
  setNotificationsAdminTitle: 'Messages administratifs',
  setNotificationsBlogTitle: 'Blog',
  setNotificationsPushOffContent: 'Les notifications Push sont désactivées',
  setNotificationsPushOffText: 'Pour les activer, veuillez accéder aux paramètres de votre appareil et autoriser les notifications',
  setReportAppFlagCurtainTitle: 'Signaler',
  setAppReportedCurtainContent: 'Contenu signalé',
  setDeleteCurtainTitle: 'Supprimer le compte',
  setDeleteCurtainInputContent: 'Mot de passe',
  setDeleteCurtainCancelButtonTitle: 'Annuler',
  setDeleteCurtainConfirmButtonTitle: 'Confirmer',
  setDeleteCurtainIncorrectPasswordAlertText: 'Mot de passe incorrect',
  setTurnNotificationsOnText:
    'Pour les activer, veuillez cliquer sur le bouton ci-dessous et autoriser la réception des notifications.',
  setTurnNotificationsOnButton: 'Activer les notifications Push',
  changeLanguage: "Changer la langue de l'application",
  changeLanguageAlertSuccess: "La langue de l'application a été changée avec succès"
}
